export const GET_TASK_TYPES_AJAX_SUCCESS = "GET_TASK_TYPES_AJAX_SUCCESS";